import { render, staticRenderFns } from "./Modifypwd.vue?vue&type=template&id=bfaa9484"
import script from "./Modifypwd.vue?vue&type=script&lang=js"
export * from "./Modifypwd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports